export class RestoreCartModel {
  cartName: string;
  keepRestoredCart: boolean;
  preventSaveActiveCart: boolean;
}
